import { useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { isPrelandPage } from 'helpers/route';
import { useAutoRedirectQuery } from 'hooks/queries/useAutoRedirectQuery';
import { useAppRouteEvents } from 'hooks/useAppRouteEvents';
import { useSystemSearchQueries } from 'hooks/useSystemSearchQueries';

export const useIdleAutoredirect = () => {
  const location = useLocation();

  const { getDelayQuery } = useSystemSearchQueries();
  const { key: delayQueryKey, value: delayQueryValue } = getDelayQuery();

  const delay = useRef(delayQueryValue);

  const autoRedirectQuery = useAutoRedirectQuery({
    enabled: false,
    onSuccess: (data) => {
      const mergedQueries = {
        ...data.add_params,
        [delayQueryKey]: delay.current,
        path: location.pathname,
      };

      if (process.env.NODE_ENV === 'development') return;

      window.location.href = `${data.redirect_url}?${queryString.stringify(
        mergedQueries
      )}`;
    },
  });

  const isIdleTimerEnabled =
    delay.current && Number.isInteger(Number(delay.current));

  const idleTimer = useIdleTimer({
    onIdle: () => autoRedirectQuery.refetch(),
    timeout: 1000 * Number(delay.current),
    startOnMount: false,
    startManually: true,
    stopOnIdle: false,
    crossTab: false,
  });

  useAppRouteEvents({
    onLoadStart: () => {
      idleTimer.pause();
    },
    onLoadEnd: () => {
      if (isIdleTimerEnabled && isPrelandPage(location.pathname)) {
        idleTimer.start();
      }
    },
  });
};
